<div style="margin: 0px; padding: 0px; width: 100%; height: 90%; position: absolute; overflow: hidden; background-color: #fff;">
	<table style="width: 100%; height: 100%; color: #000; text-align: center; font-size: 40px;">
		<tr>
			<td style="background-repeat: no-repeat; background-size: cover; background-image: url('assets/images/anonymousDataTransfer.png'); vertical-align:bottom; padding:20px;">
				<div *ngIf="uiType==0">
					<div style="font-size:28px;">
						Just One Sec
					</div>
					<div>
						We're setting up your new digs.<br />
						And we guarentee your'll like exploring this.
					</div>
				</div>
				<div *ngIf="uiType==1">
					<div style="font-size:16px;">
						Wooo hooo!
					</div>
					<div>
						Your account is ready and waiting.
					</div>
				</div>
				<div *ngIf="uiType==2">
					<div>
						Looks like you have already transferred your <b>info</b>! Enjoy using Journeys Map!
					</div>
					<div>
						<button class="btn btn-primary" (click)="close($event)" style="width: 100px;">Next</button>
					</div>
				</div>
				<div *ngIf="uiType==7">
					Failed to transfer. Please copy/paste the link and retry.
				</div>
				<div *ngIf="uiType==8">
					Failed to transfer. Data transfer link is invalid. Please copy/paste the link and retry.
				</div>
			</td>
		</tr>
		<tr>
			<td style="height:50px; padding:15px; vertical-align:top;">&nbsp;</td>
		</tr>
	</table>
</div>
